<template>
    <div class="container">
        <div class="activate_icon-success">
            <img src="../assets/images/ic-check.svg" v-if="!ac" />
            <img src="../assets/images/ic-check-ac.svg" v-if="ac" />
        </div>
        <h2
            class="activate_title"
            :class="{ 'ac-color-yellow': ac }"
            v-html="title"
        ></h2>
        <p class="activate_info" v-html="info"></p>
        <p class="activate_info" v-html="subInfo"></p>
        <span id="protocol" class="activate_protocol">
            {{ labelProtocol }} {{ protocol }}
        </span>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	data() {
		return {
			title: '',
			info: '',
			subInfo: '',
			labelProtocol: '',
		};
	},
	computed: {
		...mapState({
			config: (state) => state.config,
			ac: (state) => state.ac,
			protocol: (state) => state.protocol,
        })
    },
	async created() {
		const config = this.config.pageSucess;
		this.title = config.default.title;
		this.info = config.default.info;
		this.subInfo = config.default.subInfo;
		this.labelProtocol = config.default.protocolo;
			
		if (this.protocol === '') return this.$router.push('/chip');
	}
}
</script>